it("should handle the raw loader correctly", function() {
	require("raw!../_resources/abc.txt").should.be.eql("abc");
});



/*****************
 ** WEBPACK FOOTER
 ** ./loaders/raw-loader/index.js
 ** module id = 0
 ** module chunks = 0
 **/